const locale = require('./gridDataBrowser.i18n.json');

/*@ngInject*/
const GridDataBrowserController = function ($rootScope, currentUserModel, $scope, $timeout, $element, $state, coreConstant, advancedFilterModel, advancedFilterMediator, navigationStateModel, gridDataBrowserConstant, formTemplateStatus, uIFormTemplateAction) {

    this.$onInit = function () {
        $element.addClass('gridDataBrowser');
        $element.addClass(this.identifier);

        this.i18n = locale;

        this.isLoading = true;
        this.filterModel = null;

        this.items = [];
        this.totalItems = 0;
        this.isGridEmpty = true;

        this.isBulkActionActive = false;
        this.activeBulkAction = null;
        this.bulkActionLabel = '';
        this.isBulkActionAllSelected = false;
        this.isBulkActionAllProcessing = false;
        this.bulkActionLastSelectedIndex = -1;
        this.bulkActionCount = 0;
        this.bulkActionSelectedItems = [];
        this.bulkActionFilterUri = null;
        this.bulkActionExcludedItems = [];

        this.requestParams = {
            key: this.initialRequestParams.key,
            startIndex: this.initialRequestParams.startIndex,
            pageSize: this.initialRequestParams.pageSize,
            sortType: this.initialRequestParams.sortType
        };

        this.actions = [];
        this.hiddenInputActions = {};
        this.context = {
            identifier: this.identifier,
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        this.context.actions[coreConstant.CONTEXT_NONE] = '';

        this.resetNavigationState();
        this.loadFilter();
        this.loadActions();
    };

    this.isShowSelector = function() {
        return this.showSelector || this.isBulkActionActive;
    };

    this.loadActions = function () {
        this.loadActionsHandler().then((actions) => {
            let allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });
            this.actions = allActions;

            this.hiddenInputActions = actions.hiddenInputActions;

            this.actionsTimeLastModified = new Date().getTime();

            if (allActions.length===1 && allActions[0].actions && allActions[0].actions.length===1 && allActions[0].actions[0].defaultExecute) {
                this.handleAction(allActions[0].actions[0]);
            }
        });
    };

    this.loadItems = function () {
        this.isLoading = true;

        return this.loadItemsHandler(this.filterModel.filter.uri, this.requestParams).then((items) => {
            this.items = items.records;
            this.totalItems = items.totalRecords;
            this.isGridEmpty = this.totalItems === 0;

            // specific to dynamicGrid
            if (!this.isBulkActionActive && this.showSelector) {
                if (this.items) {
                    if(this.isBulkActionActive &&  this.activeBulkAction.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
                        const originalItemslength = this.items.length;
                        this.items = _.filter(this.items, item => item.isValid);
                        this.totalItems = items.totalRecords - (originalItemslength - this.items.length);
                        this.isGridEmpty = this.totalItems === 0;
                    }
                    _.each(this.items, (item) => {
                        if (item.selected && !this.bulkActionSelectedItems.find(function(i) {return i.id===item.id})) {
                            this.bulkActionSelectedItems.push(item);
                        }
                    });
                }
                $scope.$emit(coreConstant.event.gridSelectionChanged, this.bulkActionSelectedItems);
            }

            $timeout(() => {
                $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
                this.isLoading = false;
            }, 0);
        });
    };

    this.useFilter = function (filter) {
        if (!_.isNil(filter)) {
            advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then((filterTemplate) => {
                advancedFilterModel.buildFilter(this.advancedFilterType, filterTemplate, filter, true);
                this.filterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
                this.loadItems();
            });
        }
    };

    this.loadFilter = function () {
        const existingFilterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
        if (!this.loadFilterHandler && !_.isNil(existingFilterModel) && !_.isNil(existingFilterModel.filter)) {
            this.filterModel = existingFilterModel;
            this.loadItems();
        } else {
            if (this.loadFilterHandler) {
                this.loadFilterHandler().then((filter) => {
                    this.useFilter(filter);
                });
            }
            else {
                advancedFilterMediator.getFilters(this.filterType).then((filters) => {
                    const filter = _.first(filters);
                    this.useFilter(filter);
                });
            }
        }
    };

    this.onClickRow = function (event, item) {
        if (this.isShowSelector()) {
            this.handleBulkActionRowSelection(event, item, true);
        } else {
            const detailState = this.stateParams.getDetailState(item);

            const navigationModel = {
                parentState: this.stateParams.browser,
                currentState: detailState.name,
                data: detailState.params
            };

            $state.go(detailState.name, detailState.params);

            navigationStateModel.saveViewState(this.stateParams.browser, navigationModel);
        }
    };

    this.onPagingChange = function (event, params) {
        this.requestParams.startIndex = params.startIndex;
        this.bulkActionLastSelectedIndex = -1;

        this.loadItems().then(() => {
            this.updateBulkActionSelection();
        });
    };

    this.onSortChange = function (event, params) {
        this.requestParams.key = params.key;
        this.requestParams.sortType = params.sortType;
        this.bulkActionLastSelectedIndex = -1;
        this.loadItems().then(() => {
            this.updateBulkActionSelection();
        });
    };

    this.resetNavigationState = function () {
        navigationStateModel.saveViewState(this.stateParams.browser, null);
    };

    this.handleAction = function (action, file) {
        if (action.isBulkAction && action.enabled) {
            if(action.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES){
                this.applyCriterionFilters({'Status' : formTemplateStatus.DRAFT});
            }
            this.isBulkActionActive = true;
            this.activeBulkAction = action;
        } else {
            this.notifyHandleAction({action: action, file: file});
        }
    };

    this.onBulkAction = function () {
        this.notifyHandleBulkAction({
            action: this.activeBulkAction,
            selectedItems: this.bulkActionSelectedItems,
            excludedItems: this.bulkActionExcludedItems,
            filterUri: this.bulkActionFilterUri
        });
    };

    this.onCancelBulkAction = function () {
        this.resetBulkActionState();
    };

    this.onBulkActionCheckboxClick = function (event, item) {
        this.handleBulkActionRowSelection(event, item, false);
        if (event) {
            event.stopPropagation();
        }
    };

    this.onBulkActionAllCheckboxClick = function () {
        this.bulkActionSelectedItems = [];
        this.bulkActionFilterUri = null;
        this.bulkActionExcludedItems = [];
        this.isBulkActionAllProcessing = this.isBulkActionAllSelected;

        _.each(this.items, (item) => {
            item.selected = this.isBulkActionAllProcessing;
            // specific to dynamicGrid
            if (!this.isBulkActionActive && this.showSelector) {
                if (item.selected && this.bulkActionSelectedItems.indexOf(item)<0) {
                    this.bulkActionSelectedItems.push(item);
                }
                else if (this.bulkActionSelectedItems.indexOf(item)>=0) {
                    this.bulkActionSelectedItems.splice(this.bulkActionSelectedItems.indexOf(item), 1);
                }
            }
        });

        if (this.isBulkActionAllProcessing) {
            this.bulkActionFilterUri = this.filterModel.filter.uri;
            this.bulkActionCount = this.totalItems;
        } else {
            this.bulkActionCount = 0;
        }

        $scope.$emit(coreConstant.event.gridSelectionChanged, this.bulkActionSelectedItems);
    };

    this.updateBulkActionSelection = function () {
        if (this.isBulkActionAllProcessing) {
            this.bulkActionCount = this.totalItems - _.size(this.bulkActionExcludedItems);
            _.each(this.items, (item) => {
                const exclusions = _.find(this.bulkActionExcludedItems, (bulkActionExcludedItem) => {
                    return bulkActionExcludedItem.id === item.id;
                });
                item.selected = _.isNil(exclusions);
            });
        } else {
            _.each(this.items, (item) => {
                const selected = _.find(this.bulkActionSelectedItems, (bulkActionSelectedItem) => {
                    return bulkActionSelectedItem.id === item.id;
                });
                item.selected = !_.isNil(selected);
            });
        }
    };

    this.resetBulkActionState = function () {
        this.resetPublishFormTemplatesActionState();
        this.isBulkActionActive = false;
        this.activeBulkAction = null;
        this.isBulkActionAllSelected = false;
        this.isBulkActionAllProcessing = false;
        this.bulkActionCount = 0;
        this.bulkActionSelectedItems = [];
        this.bulkActionFilterUri = null;
        this.bulkActionExcludedItems = [];
        _.each(this.items, (item) => {
            if (item.selected) {
                item.selected = false;
            }
        });
    };

    this.handleBulkActionRowSelection = function (event, rowItem, toggleSelected) {

        if (this.singleSelect) {
            _.each(this.items, (item, index) => {
                if (item.id !== rowItem.id) {
                    item.selected = false;
                }
            });
            rowItem.selected = true;
            this.handleBulkActionSelection(rowItem, null);
            this.bulkActionCount = 1;
        }
        else {
            const shiftKeyPressed = event && event.shiftKey,
                  previouslySelected = this.handleBulkActionCheckboxToggle(rowItem, toggleSelected, shiftKeyPressed);
            this.handleBulkActionSelection(rowItem, previouslySelected);
            if (shiftKeyPressed) {
                this.handleBulkActionShiftKeySelection(rowItem);
            } else if (!_.isNil(event)) {
                _.each(this.items, (item, index) => {
                    if (item.id === rowItem.id) {
                        this.bulkActionLastSelectedIndex = index;
                        return false;
                    }
                });
            }
        }
    };

    this.handleBulkActionCheckboxToggle = function (item, toggleSelected, shiftKeyPressed) {
        let previouslySelected = false;

        if (toggleSelected && !shiftKeyPressed) {
            item.selected = !item.selected;
        } else if (shiftKeyPressed) {
            previouslySelected = toggleSelected ? item.selected : !item.selected;
            item.selected = true;
        }

        return previouslySelected;
    };

    this.handleBulkActionSelection = function (item, previouslySelected) {
        if (this.singleSelect) {
            this.bulkActionSelectedItems = [];
        }
        if (item.selected) {
            if (!previouslySelected) {
                this.bulkActionCount++;
                /* this.showSelector is direct select mode -- doesn't use exclude mode */
                if (!_.isNil(this.bulkActionFilterUri) && !this.showSelector) {
                    _.remove(this.bulkActionExcludedItems, (bulkActionExcludedItem) => {
                        return bulkActionExcludedItem.id === item.id;
                    });
                } else {
                    this.bulkActionSelectedItems.push(item);
                }
            }
        } else {
            this.isBulkActionAllSelected = false;
            this.bulkActionCount--;
            if (!_.isNil(this.bulkActionFilterUri) && !this.showSelector) {
                this.bulkActionExcludedItems.push(item);
            } else {
                _.remove(this.bulkActionSelectedItems, (bulkActionSelectedItem) => {
                    return bulkActionSelectedItem.id === item.id;
                });
            }
        }

        $scope.$emit(coreConstant.event.gridSelectionChanged, this.bulkActionSelectedItems);
    };

    this.handleBulkActionShiftKeySelection = function (rowItem) {
        let currentSelectedIndex;

        _.each(this.items, (item, index) => {
            if (item.id === rowItem.id) {
                currentSelectedIndex = index;
                return false;
            }
        });

        _.each(this.items, (item, index) => {
            if (index < currentSelectedIndex && index > this.bulkActionLastSelectedIndex ||
                index > currentSelectedIndex && index < this.bulkActionLastSelectedIndex) {
                if (!item.selected) {
                    this.handleBulkActionRowSelection(null, item, true);
                }
            }
        });
    };

    this.onGridMouseDown = function (event) {
        if(event.target.offsetWidth <= event.clientX+15 ){
            $timeout(() => {
                $('.datagrid').click();
            }, 0);
        }
    };

    $scope.$on(coreConstant.event.FILTER_SAVED, (event, filter) => {
        advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).filter = filter;
        $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    });

    $scope.$on(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE, () => {
        this.resetBulkActionState();
        this.loadFilter();
        $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    });

    this.applyCriterionFilters = function (criterionFilters) {
        let currentFilterChanged;
        let filterNames = Object.keys(criterionFilters);
        const selectedCriterionTemplates = this.filterModel .selectedFilterCriterionTemplates;
        _.each(selectedCriterionTemplates, (selectedCriterionTemplate) => {
            if(_.isEmpty(filterNames)){
                return false;
            }
            if (filterNames.includes(selectedCriterionTemplate.name)) {
                selectedCriterionTemplate.value = criterionFilters[selectedCriterionTemplate.name];
                currentFilterChanged = true;
                _.pull(filterNames, selectedCriterionTemplate.name);
            }
        });
        if(currentFilterChanged){
            this.isLoading = true;
            this.updateFilter();
        }
    };

    this.resetPublishFormTemplatesActionState = () => {
        if(this.activeBulkAction.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES){
            this.applyCriterionFilters({'Status':''});
        }
    }

    this.updateFilter = function () {
        let filter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
        if (!advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).temporary) {
            filter.temporary = true;
            filter.uri = null;
        }
        filter.userId = currentUserModel.getCurrentUser().userId;
        advancedFilterMediator.saveFilter(filter).then(function (filter) {
            $scope.$emit(coreConstant.event.FILTER_SAVED, filter);
        });
    }
};

angular.module('gw-um-grid-data-browser')
    .controller('gridDataBrowserController', GridDataBrowserController);
